export default __webpack_public_path__ + "static/media/03__o_2.1bdfc0bb.jpg";